/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './nurse.reducer';

export const NurseDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const nurseEntity = useAppSelector(state => state.nurse.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="nurseDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.nurse.detail.title">Nurse</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.nurse.id">Id</Translate>
            </span>
          </dt>
          <dd>{nurseEntity.id}</dd>
          <dt>
            <span id="education">
              <Translate contentKey="tinyMedicRestApp.nurse.education">Education</Translate>
            </span>
          </dt>
          <dd>{nurseEntity.education}</dd>
          <dt>
            <span id="training">
              <Translate contentKey="tinyMedicRestApp.nurse.training">Training</Translate>
            </span>
          </dt>
          <dd>{nurseEntity.training}</dd>
          <dt>
            <span id="experience">
              <Translate contentKey="tinyMedicRestApp.nurse.experience">Experience</Translate>
            </span>
          </dt>
          <dd>{nurseEntity.experience}</dd>
          <dt>
            <span id="achievements">
              <Translate contentKey="tinyMedicRestApp.nurse.achievements">Achievements</Translate>
            </span>
          </dt>
          <dd>{nurseEntity.achievements}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.nurse.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{nurseEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.nurse.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{nurseEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.nurse.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{nurseEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.nurse.active">Active</Translate>
            </span>
          </dt>
          <dd>{nurseEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.nurse.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{nurseEntity.cursor}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.nurse.name">Name</Translate>
            </span>
          </dt>
          <dd>{nurseEntity.name}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="tinyMedicRestApp.nurse.email">Email</Translate>
            </span>
          </dt>
          <dd>{nurseEntity.email}</dd>
          <dt>
            <span id="age">
              <Translate contentKey="tinyMedicRestApp.nurse.age">Age</Translate>
            </span>
          </dt>
          <dd>{nurseEntity.age}</dd>
          <dt>
            <span id="gender">
              <Translate contentKey="tinyMedicRestApp.nurse.gender">Gender</Translate>
            </span>
          </dt>
          <dd>{nurseEntity.gender}</dd>
          <dt>
            <span id="mobile">
              <Translate contentKey="tinyMedicRestApp.nurse.mobile">Mobile</Translate>
            </span>
          </dt>
          <dd>{nurseEntity.mobile}</dd>
          <dt>
            <span id="dateOfBirth">
              <Translate contentKey="tinyMedicRestApp.nurse.dateOfBirth">Date Of Birth</Translate>
            </span>
          </dt>
          <dd>{nurseEntity.dateOfBirth}</dd>
          <dt>
            <span id="bloodGroup">
              <Translate contentKey="tinyMedicRestApp.nurse.bloodGroup">Blood Group</Translate>
            </span>
          </dt>
          <dd>{nurseEntity.bloodGroup}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.nurse.tmUser">Tm User</Translate>
          </dt>
          <dd>{nurseEntity.tmUser ? nurseEntity.tmUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.nurse.contactCode">Contact Code</Translate>
          </dt>
          <dd>{nurseEntity.contactCode ? nurseEntity.contactCode.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.nurse.hospital">Hospital</Translate>
          </dt>
          <dd>{nurseEntity.hospital ? nurseEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/nurse" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/nurse/${nurseEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default NurseDetail;
